import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "../theme";
import { H1 } from "../text";
import { Card } from "../card";
import { Logo } from "../logo";
import { Link } from "react-router-dom";
export const PublicFormLayout = ({ children, title, footer }) => (_jsxs(OffsetTop, { children: [_jsx(Center, { children: _jsx(Link, { to: "/admin", style: { display: "inline-block" }, children: _jsx(Logo, {}) }) }), _jsxs(Container, { children: [_jsx(Center, { children: _jsx(H1, { children: title }) }), children] }), footer] }));
const OffsetTop = styled.div `
  padding-top: 5%;
`;
const Center = styled.div `
  margin: 0 auto;
  text-align: center;
`;
const Container = styled(Card) `
  margin: 0 auto;
  max-width: 450px;
  padding: ${({ theme }) => `${theme.space[6]}px ${theme.space[8]}px ${theme.space[8]}px`};
`;
